import helpers from '@/helpers'

import { fetch } from '../'

const getConfig = {
  postType: 'post',
  embed: false,
  customfields: false
}
const getAllConfig = {
  postType: 'post',
  embed: false,
  customfields: false,
  body: {}
}

export default {
  async getAll (config = {}) {
    config = Object.assign({}, getAllConfig, config)
    if (window.lang) config.body.lang = window.lang
    // config.postType = config.postType === 'post' ? 'posts' : config.postType
    // if (config.embed) config.body._embed = true
    const body = helpers.createBody(config.body)
    let response = await fetch(`/wp-json/wpvue/v1/posts/${config.postType}?${body}`)
    let data = await response.json()
    if (response.ok && data) {
      // if (config.customfields) {
      //   data = Promise.all(data.map(async p => {
      //     p.meta = await customfields.get(p.id)
      //     return p
      //   }))
      // }
      return data
    } else {
      return []
    }
  },

  async get (id, config = {}) {
    if (parseInt(id) && parseInt(id) == id) {
      return this.getById(id, config)
    } else {
      return this.getBySlug(id, config)
    }
  },

  async getById (id, config = {}) {
    config = Object.assign({}, getConfig, config)
    // config.postType = config.postType === 'post' ? 'posts' : config.postType
    const queryArgs = {}
    if (config.depth) queryArgs.depth = config.depth
    if (window.lang) queryArgs.lang = window.lang
    const qs = helpers.createBody(queryArgs)
    return this.privateGet(`/wp-json/wpvue/v1/posts/${config.postType}/${id}?${qs}`, config)
  },

  async getBySlug (slug, config = {}) {
    config = Object.assign({}, getConfig, config)
    // config.postType = config.postType === 'post' ? 'posts' : config.postType
    const queryArgs = {}
    queryArgs.type = 'slug'
    if (config.depth) queryArgs.depth = config.depth
    if (window.lang) queryArgs.lang = window.lang
    const qs = helpers.createBody(queryArgs)
    return this.privateGet(`/wp-json/wpvue/v1/posts/${config.postType}/${slug}?${qs}`, config)
  },

  async privateGet (url, config) {
    let response = await fetch(url)
    let data = await response.json()
    data = Array.isArray(data) ? data[0] : data
    if (response.ok && data) {
      // if (config.customfields) {
      //   let meta = await customfields.get(data.id)
      //   data.meta = meta
      //   return data
      // } else {
      //   return data
      // }
      return data
    } else {
      return null
    }
  }
}
